export const plans = [
    {
        name: "WordPress Development",
        price: "$1600",
        note: "/month",
        subnote: "Domaim and hosting is excluded.",
        description:
            "A practical entry plan for businesses that want consistent outreach without a large monthly commitment.",
        features: [
            { label: "Custom Site Design", included: true },
            { label: "Responsive & Mobile-Friendly", included: true },
            { label: "SEO Optimization", included: true },
            { label: "Content Management System (CMS)", included: true },
            { label: "Plugin Integration", included: true },
            { label: "Performance Optimization", included: true },
            { label: "Support & Training", included: true },
            { label: "Custom Features", included: true },
        ],
        highlighted: false,
    },
    {
        name: "Custom Development",
        price: "$3000",
        note: "/month",
        subnote: "Domaim and hosting is excluded.",
        description:
            "Built for businesses ready to increase lead volume, improve follow-up quality, and keep reporting more structured.",
        features: [
            { label: "Tailored Design & Development", included: true },
            { label: "Responsive & Mobile-Friendly", included: true },
            { label: "SEO-Friendly Structure", included: true },
            { label: "Advanced Security Measures", included: true },
            { label: "Scalable Architecture", included: true },
            { label: "Third-Party Integrations", included: true },
            { label: "Performance Optimization", included: true },
            { label: "Ongoing Support & Maintenance", included: true },
            { label: "Unique Features & Functionality", included: true },
            { label: "Dynamic Blog Integration", included: true },
        ],
        highlighted: false,
    },
    {
        name: "TeleMarketing",
        price: "$1000",
        note: "/month",
        subnote: "Building network with provider to get patient referrals.",
        description:
            "A stronger plan for businesses that need deeper campaign support, better insights, and more consistent conversions.",
        features: [
            { label: "Targeted Online Campaigns", included: true },
            { label: "SEO & Local Search Optimization", included: true },
            { label: "Content Marketing", included: true },
            { label: "Social Media Engagement", included: true },
            { label: "Email Marketing", included: true },
            { label: "Online Webinars & Workshops", included: true },
            { label: "Retargeting Ads", included: true },
            { label: "Analytics & Performance Tracking", included: true },
            { label: "Reputation Management", included: true },
            { label: "Automated Follow-Ups", included: true },
        ],
        highlighted: true,
    },
    {
        name: "Digital Marketing",
        price: "$1000",
        note: "/month",
        subnote: "Aimed at improving a maximum visits",
        description:
            "A stronger plan for businesses that need deeper campaign support, better insights, and more consistent conversions.",
        features: [
            { label: "Custom Site Design", included: true },
            { label: "Responsive & Mobile-Friendly", included: true },
            { label: "SEO Optimization", included: true },
            { label: "Content Management System (CMS)", included: true },
            { label: "Plugin Integration", included: true },
            { label: "Performance Optimization", included: true },
            { label: "Support & Training", included: true },
            { label: "Custom Features", included: true },
        ],
        highlighted: false,
    },
];